import { Table } from 'antd'
import moment from 'moment'
import React, { useState } from 'react'
import CommonModal from "../../UiKits/Modals/common/modal";
import { quizValidateData } from '../../../utils/validate'
import { Btn } from '../../../AbstractElements'
import QuizAction from './QuizAction'
import { Col, Input, Label, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { addQuizData } from '../../../firebase/utils';
import { Loader } from 'react-bootstrap-typeahead';

const QuizCategory = ({ record: { quizzes, id }, data, setData }) => {
  const [show, setShow] = useState('')
  const [quizData, setQuizData] = useState({
    Duration: '',
    name: '',
    password: '',
    createdAt: Date.now(),
  })
  const [isUpdatingQuizStatus, setIsUpdatingQuizStatus] = useState({
    id: '',
    isLoading: false
  })

  const createCategory = async () => {
    if (quizValidateData(quizData)) {
      const createdCategory = await addQuizData(id, quizData)
      setData(prevState => prevState.map(obj => {
        const quizzesData = obj.quizzes.length ? [...obj.quizzes, { ...quizData, id: createdCategory.id, key: createdCategory.id }] : [{ ...quizData, id: createdCategory.id, key: createdCategory.id }]
        return obj.id === id ? { ...obj, quizzes: quizzesData } : obj
      }
      ))
      toast.success('Quiz Created')
      setShow(false)
      setQuizData({
        Duration: '',
        name: '',
        password: '',
      })
    } else {
      toast.error('Please enter all the fields')
    }
  }

  const inputChangeHandler = (e) => {
    setQuizData({
      ...quizData,
      [e.target.name]: e.target.value
    })
  }

  const tableColumns = [
    {
      title: `Quiz Name`,
      render: (e) => <>{e.name} {(isUpdatingQuizStatus.id === e.id && isUpdatingQuizStatus.isLoading) ? <Loader /> : <span className={e?.status === 'Public' ? 'text-success' : 'text-danger'}>{e?.status && `(${e?.status})`}</span>}</>
    },
    {
      title: "Review Open",
      render: (e) => <div className='d-flex align-items-center justify-content-center'>{e.showReview ? 'Open' : 'Close'}</div>
    },
    {
      title: "createdAt",
      dataIndex: 'createdAt',
      render: (e) => <div className='d-flex align-items-center justify-content-center'>{moment(e).format("MMM Do YY")}</div>

    },
    {
      title: "Password",
      dataIndex: 'password'
    },
    {
      title: "Total Questions",
      dataIndex: 'questions',
      render: (e) => <div className='d-flex align-items-center justify-content-center'>{e?.length ?? 0}</div>
    },
    {
      title: "Options",
      render: (e) => <div className='d-flex align-items-center justify-content-center'><QuizAction setData={setData} categoryId={id} mainData={data} data={e} setIsUpdatingQuizStatus={setIsUpdatingQuizStatus} /></div>
    },

  ]

  return (
    <div>
      <div>
        <Btn attrBtn={{ color: "primary", className: "m-b-10", onClick: () => setShow(true) }}>Add Quiz</Btn>
      </div>
      <Table
        columns={tableColumns}
        dataSource={quizzes}
        pagination={false}
        bordered={true}
        scroll={{ x: 'auto' }}
      />
      {show && <CommonModal
        isOpen={show}
        toggler={() => {
          setShow(false)
        }}
        successText='Create'
        title='Add new Quiz'
        success={createCategory}
      >
        <div>
          <Label htmlFor='name' className='f-w-500'>Quiz Name</Label>
          <Input id='name' name='name' value={quizData.name} onChange={inputChangeHandler} />
        </div>
        <div className='m-t-10'>
          <Row >
            <Col md={6}>
              <Label htmlFor='duration' className='f-w-500'>Quiz Duration</Label>
              <Input id='duration' type='number' name='Duration' value={quizData.Duration} onChange={inputChangeHandler} />

            </Col>
            <Col md={6}>
              <Label htmlFor='password' className='f-w-500'>Quiz Password</Label>
              <Input id='password' name='password' value={quizData.password} onChange={inputChangeHandler} />
            </Col>
          </Row>
        </div>
      </CommonModal>}

    </div>
  )
}

export default QuizCategory